import type React from 'react'

import type { Recipient } from '@/types'
import { timeAgo } from '../../utils'
import { AuthorAvatar } from '../AuthorAvatar'
import css from './styles.module.css'
import { getAuthorName } from './utils'

interface Props extends React.PropsWithChildren {
  createdAt: number
  updatedAt: number
  author: Recipient | null
  /** The name stored on the row, for a writer `author` cannot name. */
  storedName: string | null
}

export const CommentHeader: React.FC<Props> = ({
  createdAt,
  updatedAt,
  author,
  storedName,
  children,
}) => {
  const edited = createdAt !== updatedAt
  const time = timeAgo(createdAt)
  const name = getAuthorName(author, storedName)

  return (
    <div className={css.comment_header}>
      <div className={css.content}>
        <AuthorAvatar author={author} size="sm" />
        <div className={css.labels}>
          <span className={css.name}>{name}</span>
          <span className={css.time_label}>{time}</span>
          {edited && <span className={css.time_label}>Edited</span>}
        </div>
      </div>
      {children}
    </div>
  )
}
